export var mfRegistrationBookAccodeMapper = function (data) {
    var result = [];
    if (data && data.length > 0) {
        result = data.map(function (item) {
            return {
                ClientCode: item.ClientCode,
                ClientName: item.ClientName,
                TransactionDate: item.TransactionDate,
                SchemeName: item.SchemeName,
                BuySell: item.BuySell,
                OrderStatus: item.OrderStatus,
                Amount: item.Amount,
                Units: item.Units,
                OrderRemark: item.OrderRemark,
                SIPRegnNo: item.SIPRegnNo,
                Exchange: item.Exchange,
            };
        });
    }
    return result;
};
